import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import { history } from '../helpers';

import { PageActions, ImageBox, Section, TextArea, TextInput, SwitchInput, ImageInput, EditorInput } from '../components';
import DatePicker from 'react-datepicker';
import { userActions, generalActions } from '../actions';
import { generalService } from '../services';


class ProjectDetailPage extends React.Component {
  constructor(props) {
      super(props);

      this.pid = 400; //home page
      if(this.props.match.params.id != undefined){
        this.props.dispatch(generalActions.getContent(this.props.match.params.id,this.pid));  
      }else{
        this.props.dispatch(generalActions.getContent(0,0));  
      }

      this.state = {
        id: null,
        payload:{
          thumbnail: '',
          banner: '',
          category: '',
          title: '',
          year: '',
          client: '',
          area: '',
          location: '',
          service: '',
          slider1: '',
          slider2: '',
          slider3: '',
          slug:''
        },
        isLoaded :false,
        isEdit :false,
        lastEvent: null
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);

  }

  componentWillReceiveProps(props){

      const { content, upload } = props;
      const { data, id } = content;
      const { payload } = this.state;

      console.log(data,id);

      if(data && !this.state.isEdit){
        let dataPayload = {
          thumbnail: data.thumbnail,
          banner: data.banner,
          category: data.category,
          title: data.title,
          year: data.year,
          client: data.client,
          area: data.area,
          location: data.location,
          service: data.service,
          slider1: data.slider1,
          slider2: data.slider2,
          slider3: data.slider3,
          slug: data.slug
        }

        this.setState({ payload:dataPayload, id:id, isLoaded:true, isEdit:true });

      }else{

        if(!upload.uploaded){
          setTimeout(()=>this.setState({ isLoaded: true}),1000);  
        }

      }

      if(upload.uploaded){
        this.setState({payload:{...payload, [this.state.lastEvent]:upload.data}});
      }
  }

  handleChange(e) { 
    const { name, value } = e.target;
    const { payload } = this.state;

    if(name === 'title'){
      this.setState({payload:{...payload, [name]:value, slug:value.toLowerCase().replace(/[^\w ]+/g,'').replace(/ +/g,'-')}});
    }else{
      this.setState({payload:{...payload, [name]:value}});  
    }
  }

  handleFileChange(e) {
      const { name, value } = e.target;

      const file = e.target.files[0];
      const formData = new FormData();

      if(file){
        formData.set('file', file, file.name);
        
        if (formData) {
          this.props.dispatch(generalActions.postUpload(formData));
        }

        this.setState({lastEvent: name});
      }
  }

  handleSubmit(e) {
    e.preventDefault();
    const { dispatch, content } = this.props;
    const { id } = this.state;
    const payload = this.state.payload;

    this.setState({ submitted: true });

    if(id){
      dispatch(generalActions.postContent(payload, id, this.pid));  
    }else{
      dispatch(generalActions.putContent(payload, this.pid));  
    }
  }

  handleDelete(e) {
    e.preventDefault();
    const { dispatch, content } = this.props;
    const { id } = this.state;

    if(id){
      dispatch(generalActions.deleteContent(id));  
      setTimeout(()=>history.push('/projects'),1000); 
    }
  }

  render() {
    const {payload} = this.state;
    return (
      <div className={this.state.isLoaded ? "content-wrapper" : "content-wrapper loader-light"}>
      {
        this.state.isLoaded ?
        <form role="form" name="contact" className="needs-validation" noValidate="true">
          <section className="content-header clearfix">
            <h1 className="content-header-title">
              Project
            </h1>
            <div className="btn-placeholder">
              <button type="submit" className="btn btn-primary" onClick={this.handleSubmit}>
                <span className="visible-xs"><i className="fa fa-check"></i>&nbsp;</span>
                <span className="hidden-xs">Save</span>
              </button>
              <button type="submit" className="btn btn-primary" onClick={this.handleDelete}>
                <span className="visible-xs"><i className="fa fa-trash"></i>&nbsp;</span>
                <span className="hidden-xs">Delete</span>
              </button>
            </div>
          </section>
            <section className="content">
              <Section section_title="Project" section_description=''>
                <div className="form-group">
                  <ImageInput
                    input_label="Project Thumbnail"
                    input_name="thumbnail"
                    input_helper="Recommended dimensions of 720 x 960 px. Save with 50 quality in .jpg format to reduce file size."
                    input_onChange={this.handleFileChange}
                    input_value={this.state.payload.thumbnail}
                  />
                </div>
                <div className="form-group">
                  <ImageInput
                    input_label="Project Banner"
                    input_name="banner"
                    input_helper="Recommended dimensions of 1110 x 350 px. Save with 50 quality in .jpg format to reduce file size."
                    input_onChange={this.handleFileChange}
                    input_value={this.state.payload.banner}
                  />
                </div>
                <div className="form-group">
                  <label className="form-control-label">Project Category</label>
                  <select className="form-control" name="category" value={this.state.payload.category} onChange={this.handleChange}>
                    <option value=""> -- Select category -- </option>
                    <option value="food">Food &amp; Beverage</option>
                    <option value="hospitality">Hospitality</option>
                    <option value="office">Office</option>
                    <option value="retail">Retail &amp; Commercial</option>
                    <option value="residential">Residential</option>
                  </select>
                </div>
              </Section>
              <Section section_title="Project Details" section_description=''>
                <div className="form-group">
                  <div style={{display:'flex', flexDirection:'row'}}>
                  <ImageInput
                    input_label="Slider 1"
                    input_name="slider1"
                    input_helper="Recommended dimensions of 545 × 344 px. Save with 50 quality in .jpg format to reduce file size."
                    input_onChange={this.handleFileChange}
                    input_value={this.state.payload.slider1}
                  />
                  <ImageInput
                    input_label="Slider 2"
                    input_name="slider2"
                    input_helper="Recommended dimensions of 545 × 344 px. Save with 50 quality in .jpg format to reduce file size."
                    input_onChange={this.handleFileChange}
                    input_value={this.state.payload.slider2}
                  />
                  <ImageInput
                    input_label="Slider 3"
                    input_name="slider3"
                    input_helper="Recommended dimensions of 545 × 344 px. Save with 50 quality in .jpg format to reduce file size."
                    input_onChange={this.handleFileChange}
                    input_value={this.state.payload.slider3}
                  />
                  </div>
                  <TextInput
                    input_label="Project Title"
                    input_placeholder="Enter Project Title"
                    input_name="title"
                    input_type="text"
                    input_is_required={true}
                    input_onChange={this.handleChange}
                    input_value={this.state.payload.title}
                  />
                  <TextInput
                    input_label="Project Year"
                    input_placeholder="Enter Project Year"
                    input_name="year"
                    input_type="text"
                    input_is_required={true}
                    input_onChange={this.handleChange}
                    input_value={this.state.payload.year}
                  />
                  <TextInput
                    input_label="Client"
                    input_placeholder="Enter Client"
                    input_name="client"
                    input_type="text"
                    input_is_required={true}
                    input_onChange={this.handleChange}
                    input_value={this.state.payload.client}
                  />
                  <TextInput
                    input_label="Project Area"
                    input_placeholder="Enter Project Location"
                    input_name="area"
                    input_type="text"
                    input_is_required={true}
                    input_onChange={this.handleChange}
                    input_value={this.state.payload.area}
                  />
                  <TextInput
                    input_label="Project Location"
                    input_placeholder="Enter Project Location"
                    input_name="location"
                    input_type="text"
                    input_is_required={true}
                    input_onChange={this.handleChange}
                    input_value={this.state.payload.location}
                  />
                  <TextInput
                    input_label="Service"
                    input_placeholder="Enter Service"
                    input_name="service"
                    input_type="text"
                    input_is_required={true}
                    input_onChange={this.handleChange}
                    input_value={this.state.payload.service}
                  />
                </div>
              </Section>
            </section>
          </form>
          :
        <div className="loader"></div>
      }
      </div>
    );
  }
}

function mapStateToProps(state) {
    const { authentication, general } = state;
    const { content, upload } = general;
    return {
        content,
        upload
    };
}

const connectedProjectDetailPage = connect(mapStateToProps)(ProjectDetailPage);
export { connectedProjectDetailPage as ProjectDetailPage };


// WEBPACK FOOTER //
// ./src/pages/ProjectDetailPage.js